import { Location } from '@cobliteam/common-types';
import { Button, Typography } from '@cobliteam/ui/components';
import { Link } from 'react-router-dom';

import PlaceholderNoAccess from '../../assets/images/placeholder_no_access.svg?react';

interface AccessDeniedPanelProps {
  pageDescription?: string;
}

const openPermissionsHelpPage = () => {
  const a = document.createElement('a');
  a.href = 'https://suporte.cobli.co/quais-permiss%C3%B5es-cada-fun%C3%A7%C3%A3o-tem-acesso';
  a.target = '_blank';
  a.click();
};

const AccessDenied = ({ pageDescription = '' }: AccessDeniedPanelProps) => {
  return (
    <div data-testid='access-denied-panel' className='flex h-full w-full flex-col items-center justify-center gap-5'>
      <div className='flex justify-center'>
        <PlaceholderNoAccess />
      </div>
      <Typography variant='heading-2xl' as='h1'>
        Ops... Parece que você está sem acesso.
      </Typography>
      <div className='flex flex-col items-center justify-center gap-2'>
        {pageDescription && <Typography variant='description-list-default'>Você está sem permissão para {pageDescription}.</Typography>}
        <Typography variant='description-list-default'>Fale com o administrador da sua frota para conseguir acesso.</Typography>
      </div>
      <Link to={Location.HOME}>
        <Button>Voltar para o início</Button>
      </Link>
      <Button variant='link' color='default' onClick={openPermissionsHelpPage}>
        Saiba mais sobre permissões
      </Button>
    </div>
  );
};

export default AccessDenied;
